"use client";

import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const bannerVariants = cva("rounded-lg border px-4 py-3 transition-colors", {
  variants: {
    variant: {
      default: "bg-banner border-banner-border",
      danger: "bg-banner-danger border-banner-danger-border",
      warning: "bg-banner-warning border-banner-warning-border",
      info: "bg-banner-info border-banner-info-border",
      success: "bg-banner-success border-banner-success-border",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface BannerProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof bannerVariants> {}

function Banner({ className, variant, ...props }: BannerProps) {
  return <div className={cn(bannerVariants({ variant }), className)} {...props} />;
}

export { Banner, bannerVariants };
